// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var customBreakpoint = Theme__Responsive$PrezzeeRibbon.mediaMin(840);

var grid = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
      BsCssJs$PrezzeeRibbon.justifyContent("spaceBetween"),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-10)),
      BsCssJs$PrezzeeRibbon.media(customBreakpoint, [
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.zero),
            BsCssJs$PrezzeeRibbon.display("grid"),
            BsCssJs$PrezzeeRibbon.gridTemplateRows([{
                    NAME: "repeat",
                    VAL: [
                      {
                        NAME: "num",
                        VAL: 4
                      },
                      BsCssJs$PrezzeeRibbon.fr(1)
                    ]
                  }]),
            BsCssJs$PrezzeeRibbon.gridTemplateColumns([
                  BsCssJs$PrezzeeRibbon.fr(32),
                  BsCssJs$PrezzeeRibbon.fr(40),
                  BsCssJs$PrezzeeRibbon.fr(16),
                  BsCssJs$PrezzeeRibbon.fr(12)
                ]),
            BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(20)),
            BsCssJs$PrezzeeRibbon.gridTemplateAreas({
                  NAME: "areas",
                  VAL: [
                    ". top top .",
                    "left top top .",
                    "left bottom right right",
                    "left bottom right right"
                  ]
                })
          ]),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(10)),
            BsCssJs$PrezzeeRibbon.media(customBreakpoint, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.zero)]),
            BsCssJs$PrezzeeRibbon.firstChild([
                  BsCssJs$PrezzeeRibbon.gridArea({
                        NAME: "ident",
                        VAL: "left"
                      }),
                  BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(175)),
                  BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(22)),
                  BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                  BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(175)),
                  BsCssJs$PrezzeeRibbon.media(customBreakpoint, [
                        BsCssJs$PrezzeeRibbon.width("auto"),
                        BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
                        BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(20))
                      ]),
                  BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(326))])
                ]),
            BsCssJs$PrezzeeRibbon.nthChild({
                  NAME: "n",
                  VAL: 2
                }, [
                  BsCssJs$PrezzeeRibbon.gridArea({
                        NAME: "ident",
                        VAL: "top"
                      }),
                  BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(22)),
                  BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                  BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(175)),
                  BsCssJs$PrezzeeRibbon.media(customBreakpoint, [BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(26))]),
                  BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(30))])
                ]),
            BsCssJs$PrezzeeRibbon.nthChild({
                  NAME: "n",
                  VAL: 3
                }, [
                  BsCssJs$PrezzeeRibbon.gridArea({
                        NAME: "ident",
                        VAL: "bottom"
                      }),
                  BsCssJs$PrezzeeRibbon.unsafe("width", "calc(50% - 5px)"),
                  BsCssJs$PrezzeeRibbon.media(customBreakpoint, [BsCssJs$PrezzeeRibbon.width("auto")])
                ]),
            BsCssJs$PrezzeeRibbon.lastChild([
                  BsCssJs$PrezzeeRibbon.gridArea({
                        NAME: "ident",
                        VAL: "right"
                      }),
                  BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(12)),
                  BsCssJs$PrezzeeRibbon.unsafe("width", "calc(50% - 5px)"),
                  BsCssJs$PrezzeeRibbon.media(customBreakpoint, [
                        BsCssJs$PrezzeeRibbon.width("auto"),
                        BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(16))
                      ])
                ])
          ])
    ]);

var Styles = {
  customBreakpoint: customBreakpoint,
  grid: grid
};

function StatsTileBlock(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: grid
            });
}

var make = StatsTileBlock;

export {
  Styles ,
  make ,
}
/* customBreakpoint Not a pure module */
